import { EarlySettlementEmailRequestValidatorErrors } from '../types';
import { EARLY_SETTLEMENT_OPTIONS } from '../../apis';

export const defaultEarlySettlementEmailRequestValidatorErrors: EarlySettlementEmailRequestValidatorErrors = {
    optionType: `Wrong value! It should be one of: ${EARLY_SETTLEMENT_OPTIONS.join(', ')}.`,
    required: 'Option type is required.',
};
